<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >manage_accounts</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'gender_type' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <!--      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"-->
      <!--           fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">-->
      <!--        <label for="search" class="mr-8">-->
      <!--          <mat-icon class="secondary-text">search</mat-icon>-->
    <!--        </label>-->
    <!--        <mat-form-field floatLabel="never" fxFlex="1 0 auto">-->
    <!--          <input id="search" matInput #filter placeholder="{{'main.search' | translate}}">-->
  <!--        </mat-form-field>-->
<!--      </div>-->
<!-- / SEARCH -->

<button mat-raised-button
  (click)="newType()"
  class="add-product-button mat-white-bg my-12 mt-sm-0">
  <span>{{'main.add' | translate}}</span>
</button>

</div>
<!-- / HEADER -->
<!-- CONTENT CARD -->
<div class="content-card mat-white-bg">

  <mat-table class="products-table"
    #table [dataSource]="genderTypes"
    matSort
    [@animateStagger]="{value:'50'}"
    fusePerfectScrollbar>


    <!-- Name Column -->
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let genderType">
        <p class="text-truncate">{{genderType.name}}</p>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="defaultType">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'default_type' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let genderType">
        <p class="text-truncate">{{genderType.defaultType | translate}}</p>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="isChild">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'is_child' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let genderType">
        @if (genderType.isChild) {
          <mat-icon class="active">check_circle_outline</mat-icon>
        }
        @if (!genderType.isChild) {
          <mat-icon class="no_active">highlight_off</mat-icon>
        }
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="isAdult">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'is_adult' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let genderType">
        @if (genderType.isAdult) {
          <mat-icon class="active">check_circle_outline</mat-icon>
        }
        @if (!genderType.isAdult) {
          <mat-icon class="no_active">highlight_off</mat-icon>
        }
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="onlyForAdult">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'onlyForAdult' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let genderType">
        @if (genderType.onlyForAdult) {
          <mat-icon class="active">check_circle_outline</mat-icon>
        }
        @if (!genderType.onlyForAdult) {
          <mat-icon class="no_active">highlight_off</mat-icon>
        }
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="enable">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'targetGroup.active' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let genderType">
        @if (genderType.enable) {
          <mat-icon class="active">check_circle_outline</mat-icon>
        }
        @if (!genderType.enable) {
          <mat-icon class="no_active">highlight_off</mat-icon>
        }
      </mat-cell>
    </ng-container>



    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let genderType; columns: displayedColumns;"
      class="product"
      matRipple
      (click)="editType(genderType)">
    </mat-row>

  </mat-table>
  @if (genderTypes.length === 0) {
    <div class="no-data-msg">
      <span class="mat-headline-6">{{'main.noData' | translate}}</span>
    </div>
  }

</div>
<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>
